(() => {
  if (customElements.get('teeez-collections')) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class TeeezCollections extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.items = Array.from(this.querySelectorAll('[data-col-item]'));
      this.thumb = this.querySelector('[data-thumb]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || this.items.length < 2) return;

      const mark = () => this.setAttribute('data-interacted', 'true');
      this.track.addEventListener('touchstart', mark, { once: true, passive: true });

      this.track.addEventListener('scroll', () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.update();
          if (this.track.scrollLeft > 10) {
            mark();
            const b = this.querySelector('[data-bubble]');
            if (b) b.classList.add('is-hidden');
          }
        });
      }, { passive: true });

      if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.current() - 1));
      if (this.next) this.next.addEventListener('click', () => this.goTo(this.current() + 1));
      window.addEventListener('resize', () => this.update(), { passive: true });
      this.update();
    }

    current() {
      const left = this.track.scrollLeft;
      let best = 0;
      let dist = Infinity;
      this.items.forEach((item, i) => {
        const d = Math.abs(item.offsetLeft - this.track.offsetLeft - left);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    }

    goTo(i) {
      const n = Math.max(0, Math.min(this.items.length - 1, i));
      this.track.scrollTo({
        left: this.items[n].offsetLeft - this.track.offsetLeft,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    update() {
      const sw = this.track.scrollWidth || 1;
      if (this.thumb) {
        const w = this.track.clientWidth / sw;
        this.thumb.style.width = (w * 100) + '%';
        this.thumb.style.transform = 'translateX(' + ((this.track.scrollLeft / sw) / w * 100) + '%)';
      }
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    }
  }

  customElements.define('teeez-collections', TeeezCollections);
})();
